export default "__VITE_ASSET__GbNQXfof__"